import { render, staticRenderFns } from "./resultHonor.vue?vue&type=template&id=2d40dc2c&scoped=true&"
import script from "./resultHonor.vue?vue&type=script&lang=js&"
export * from "./resultHonor.vue?vue&type=script&lang=js&"
import style0 from "./resultHonor.vue?vue&type=style&index=0&id=2d40dc2c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d40dc2c",
  null
  
)

export default component.exports